<template>
  <div>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <br/>
    <div class="container is-fluid has-text-centered" id="url_expired">
      <h4>Welcome to Doodhvale, Please wait...</h4>
    </div>
    <div id="url_valid">
      <div id="unsubscribed">
        <div style="text-align: center;">
          <div><h4>Unsubscribed from Promotional Emails. To Subscribe <input id="SubContinue" class="button5" value="Click again"  type="button"  v-on:click="reloadPage"/></h4></div>
        </div>
      </div>
      <div id="subscribed">
        <div style="text-align: center;">
          <div><h4>Subscribed for Promotional Emails. To Unsubscribe <input id="SubContinue" class="button5" value="Click again"  type="button"  v-on:click="reloadPage"/></h4></div>
        </div>
      </div>
       <div id="error">
        <div style="text-align: center;">
          <div><h4>Oops! We encountered an error. Please retry after sometime.</h4></div>
        </div>
      </div>
  </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data () {
      return {
        urlInterface: [],
        apiDataObj: [],
        isLoading: true,
        isLoaded: false,
        isFullPage: true
      }
    },
    created () {
      this.fetchData()
    },
    methods: {
      reloadPage () {
        window.location.reload()
      },
      fetchData () {
        const params = new URLSearchParams()
        var fullUrl = document.URL
        var splitUrl = fullUrl.split('unsubPromo?')
        params.append('url_str', splitUrl[1])
        axios({
          url: process.env.BASE_API + '/accounts/fetch-url-interface-data',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.urlInterface = {}
          if (response.data.status === '000001') {
            this.urlInterface.error_msg = response.data.msg
            document.getElementById('url_valid').style.display = 'none'
          } else {
            document.getElementById('url_expired').style.display = 'none'
            this.urlInterface.action_name = response.data.action_name
            this.urlInterface.url_interface_id = response.data.url_interface_id
            this.invokeUrlAction()
          }
        })
        .catch(e => {
          alert('not ok')
        })
      },
      invokeUrlAction () {
        const params = new URLSearchParams()
        params.append('url_interface_id', this.urlInterface.url_interface_id)
        params.append('action_name', this.urlInterface.action_name)
        axios({
          url: process.env.BASE_API + '/accounts/invoke-url-action',
          method: 'post',
          data: params,
          withCredentials: false,
          headers: {
          }
        })
        .then(response => {
          this.apiDataObj.response = response.data.action_response
          // console.log(response)
          if (response.data.msg.trim().toUpperCase() === 'SUCCESS') {
            if (response.data.action_response.trim().toUpperCase() === 'SUBSCRIBED') {
              document.getElementById('unsubscribed').style.display = 'none'
              document.getElementById('error').style.display = 'none'
            } else if (response.data.action_response.trim().toUpperCase() === 'UNSUBSCRIBED') {
              document.getElementById('subscribed').style.display = 'none'
              document.getElementById('error').style.display = 'none'
            } else {
              document.getElementById('unsubscribed').style.display = 'none'
              document.getElementById('subscribed').style.display = 'none'
            }
          }
          this.isLoading = false
        })
        .catch(e => {
          alert('not ok')
        })
      }
    }
  }
</script>
<style>
.loading-icon:before {content: "Wait...";}
.loading-overlay .loading-icon:after {
  animation: spinAround 500ms infinite linear;
  border: 2px solid #3CB6C3;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  content: "";
  display: block;
  height: 1em;
  position: relative;
  width: 1em;
  position: absolute;
  top: calc(50% - 1.5em);
  left: calc(50% - 1.5em);
  width: 3em;
  height: 3em;
  border-width: 0.25em;
}
.button5 {background-color: #3CB6C3; padding: 5px 20px 5px 20px; margin-bottom: 40%; color: white; border: none; border-radius: 5% 5% 5% 5%;cursor: pointer;}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/UnsubPromo.vue